import React from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import './NavBar.css';

const NavigationBar: React.FC = () => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="navbar-container">
      <Navbar.Brand href="#home">
        <img
          alt=""
          src="/ms_games_blk_red_neg_200x37-2.png"
          className="d-inline-block align-top navbar-logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
        </Nav>
        <Nav.Link href="/" className="navbar-links">
          Home
        </Nav.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavigationBar;
